/**
 * Manage, Catalog (plan docs/plans/lms-plan.md 8.1, 6.5, 6.6, section 13
 * tab 7, 18.3, 18.17, 18.22; WP-44; R8, R10, R11).
 *
 * tabs/manage/subviews.ts imports this file's DEFAULT export (a component
 * with no required props) and ManageTab mounts it under the nested route
 * "catalog/*" (18.3), so the relative routes below resolve under
 * /lms/manage/catalog/:
 *
 *   (index)                              the course list by category, the
 *                                        built-in catalog install, New course
 *                                        and New scenario (CourseList)
 *   courses/:courseId                    one course: details, versions, new
 *                                        draft, compare, retire (CoursePage)
 *   versions/:versionId                  the draft editor with autosave, the
 *                                        lint and the publish dialog; a
 *                                        published version read-only
 *                                        (VersionEditor)
 *   versions/:versionId/preview          the player's components against the
 *                                        version's content (VersionPreview)
 *   versions/:versionId/diff/:otherId    what changed between two versions
 *                                        (DiffView)
 *   build                                the course builder's wizard
 *                                        (?course=<id>: extend mode;
 *                                        BuildWizard, builder plan 8.2)
 *   runs/:runId                          one builder run's progress and
 *                                        outcome (RunPage, builder plan 8.2)
 *   sources/:sourceId                    an uploaded builder source, opened
 *                                        through its presigned address (the
 *                                        link a built course's sources list
 *                                        carries, builder plan 7.3)
 *
 * The three builder routes show their own "not switched on" notice when GET
 * /health says the builder is off (builder plan G20); the entry buttons are
 * not rendered at all then.
 *
 * Anything else under catalog/ goes back to the list. Every call is an lms
 * admin route (requireLmsAdmin); the Manage tab is shown to lms admins only,
 * and the server re-checks every request (4.2).
 */
import { Navigate, Route, Routes } from 'react-router-dom';
import { BuildWizard } from './builder/BuildWizard';
import { RunPage, SourceOpenPage } from './builder/RunPage';
import { CoursePage } from './CoursePage';
import { CourseList } from './CourseList';
import { DiffView } from './DiffView';
import { catalogPaths } from './model';
import { VersionEditor } from './VersionEditor';
import { PreviewPage } from './VersionPreview';

export function CatalogView() {
  return (
    <div data-testid="lms-catalog">
      <Routes>
        <Route index element={<CourseList />} />
        <Route path="courses/:courseId" element={<CoursePage />} />
        <Route path="versions/:versionId" element={<VersionEditor />} />
        <Route path="versions/:versionId/preview" element={<PreviewPage />} />
        <Route path="versions/:versionId/diff/:otherId" element={<DiffView />} />
        <Route path="build" element={<BuildWizard />} />
        <Route path="runs/:runId" element={<RunPage />} />
        <Route path="sources/:sourceId" element={<SourceOpenPage />} />
        <Route path="*" element={<Navigate to={catalogPaths.list()} replace />} />
      </Routes>
    </div>
  );
}

export default CatalogView;
